import { Category } from 'app/shared/models/Category';
import { Exercise } from './Exercises';

export interface IModule {
  /** Visible title of the Module */
  title: {
    internal: string;
    de: string;
    en: string;
  };

  description: {
    internal: string;
    de: string;
    en: string;
  };

  _id: string;

  /** Categories included in this Module */
  categories: Category[];

  /** IDs of Exercises included in this Module */
  exerciseIds: string[];

  /** preview or thumbnail image of this module */
  previewUrl: string;

  /** Defines what happens when clicking on a program on frontend */
  behavior: 'random' | 'category-select';

  /** The number of random Exercises included in a Program  */
  randomProgramSize: number;
}

export class Module {
  _id: string;

  title: {
    internal: string;
    de: string;
    en: string;
  };

  description: {
    internal: string;
    de: string;
    en: string;
  };

  categories: Category[];
  exerciseIds: string[];
  exercises: Exercise[];
  previewUrl: string;
  behavior: 'random' | 'category-select' | 'kids';
  randomProgramSize: number;

  static fromJson(data: IModule): Module {
    let m = new Module();

    Object.keys(data).forEach((key) => {
      m[key] = data[key];
    });

    m.title = m.title || { de: '', internal: '', en: '' };
    m.description = m.description || { de: '', internal: '', en: '' };

    return m;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/models/Module.ts